import { Client } from "../domain/clients";
import { clientStore } from "../infrastructure/store/clientStore";
import { getClientByIdService } from "../infrastructure/services/getClientByIdService";

export const getClientById = {
  async execute(clientId: string): Promise<Client> {
    if (!clientStore().matchClient(clientId)) {
      const client = await getClientByIdService.execute(clientId);
      await clientStore().updateClientSession(client);
    }

    return clientStore().memoryClient;
  },
};


